import { render } from "./Determinado.vue?vue&type=template&id=f6b48cc0"
import script from "./Determinado.vue?vue&type=script&lang=js"
export * from "./Determinado.vue?vue&type=script&lang=js"

import "./Determinado.vue?vue&type=style&index=0&id=f6b48cc0&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__